export const PRICE_FILTERS = [
  {
    id: "price-id-1",
    name: "Dưới 10 triệu",
    max: 10000000,
  },
  {
    id: "price-id-2",
    name: "10 triệu - 20 triệu",
    min: 10000000,
    max: 20000000,
  },
  {
    id: "price-id-3",
    name: "20 triệu - 30 triệu",
    min: 20000000,
    max: 30000000,
  },
  {
    id: "price-id-4",
    name: "30 triệu - 40 triệu",
    min: 30000000,
    max: 40000000,
  },
  {
    id: "price-id-5",
    name: "40 triệu trở lên",
    min: 40000000,
  },
];
export const SORT_FILTERS = [
  {
    id: "sort-id-1",
    name: "A - Z",
  },
  {
    id: "sort-id-2",
    name: "Z - A",
  },
  {
    id: "sort-id-3",
    name: "Giá thấp dần",
  },
  {
    id: "sort-id-4",
    name: "Giá tăng dần",
  },
];

export const BRAND_FILTERS = {
  1: [
    {
      id: "brand-laptop-id-1",
      name: "ASUS",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_asus_ngang_ac594ab664.png",
    },
    {
      id: "brand-laptop-id-2",
      name: "HP",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_hp_ngang_b77a1ee753.png",
    },
    {
      id: "brand-laptop-id-3",
      name: "LENOVO",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_lenovo_ngang_9db13437a1.png",
    },
    {
      id: "brand-laptop-id-4",
      name: "ACER",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_acer_ngang_38e8924b9d.png",
    },
    {
      id: "brand-laptop-id-5",
      name: "DELL",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_dell_ngang_5152294265.png",
    },
    {
      id: "brand-laptop-id-6",
      name: "MacBook",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_macbook_ngang_dde8d75478.png",
    },
    {
      id: "brand-laptop-id-7",
      name: "MSI",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_msi_ngang_fff5dcae79.png",
    },
    {
      id: "brand-laptop-id-8",
      name: "GIGABYTE",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_gigabyte_ngang_45160dcb56.png",
    },
    {
      id: "brand-laptop-id-9",
      name: "LG",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_lg_ngang_bf97e628d1.png",
    },
  ],
  2: [
    {
      id: "brand-phone-1",
      name: "iphone",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_iphone_ngang_eac93ff477.png",
    },
    {
      id: "brand-phone-2",
      name: "samsung",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_samsung_ngang_1624d75bd8.png",
    },
    {
      id: "brand-phone-3",
      name: "xiaomi",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_xiaomi_ngang_0faf267234.png",
    },
    {
      id: "brand-phone-4",
      name: "oppo",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_oppo_ngang_68d31fcd73.png",
    },
    {
      id: "brand-phone-5",
      name: "tecno",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_tecno_ngang_c587e5f1fa.png",
    },
    {
      id: "brand-phone-6",
      name: "realme",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_realme_ngang_0185815a13.png",
    },
    {
      id: "brand-phone-7",
      name: "vivo",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_vivo_ngang_45494ff733.png",
    },
    {
      id: "brand-phone-8",
      name: "nubia",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_zte_ngang_2e0d8b4de1.png",
    },
    {
      id: "brand-phone-9",
      name: "nokia",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_nokia_ngang_15416db151.png",
    },
  ],

  3: [
    {
      id: "brand-watch-id-1",
      name: "watch",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_apple_watch_ngang_30f4bc9bfc.png",
    },
    {
      id: "brand-watch-id-2",
      name: "samsung",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_samsung_ngang_1624d75bd8.png",
    },
    {
      id: "brand-watch-id-3",
      name: "xiaomi",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_xiaomi_ngang_0faf267234.png",
    },
    {
      id: "brand-watch-id-4",
      name: "huawei",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_huawei_ngang_64107bb39f.png",
    },
    {
      id: "brand-watch-id-6",
      name: "masstel",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_masstel_ngang_2a96b9898c.png",
    },
    {
      id: "brand-watch-id-7",
      name: "kospet",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_kospet_ngang_4a3a56a336.png",
    },
    {
      id: "brand-watch-id-8",
      name: "oppo",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_oppo_ngang_68d31fcd73.png",
    },
  ],
  4: [
    {
      id: "brand-tivi-id-1",
      name: "samsung",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_samsung_ngang_1624d75bd8.png",
    },
    {
      id: "brand-tivi-id-2",
      name: "xiaomi",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_xiaomi_ngang_0faf267234.png",
    },
    {
      id: "brand-tivi-id-3",
      name: "LG",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_lg_ngang_bf97e628d1.png",
    },
    {
      id: "brand-tivi-id-4",
      name: "sony",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_sony_ngang_605fd1874e.png",
    },

    {
      id: "brand-tivi-id-7",
      name: "hisense",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_hisense_ngang_209f97a6a3.png",
    },

    {
      id: "brand-tivi-id-9",
      name: "TCL",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_tcl_ngang_0ed4175607.png",
    },
  ],
  5: [
    {
      id: "brand-screen-id-1",
      name: "viewsonic",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_viewsonic_ngang_76b2365196.png",
    },
    {
      id: "brand-screen-id-2",
      name: "xiaomi",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_xiaomi_ngang_0faf267234.png",
    },
    {
      id: "brand-screen-id-3",
      name: "lenovo",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_lenovo_ngang_9db13437a1.png",
    },
    {
      id: "brand-screen-id-4",
      name: "dell",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_dell_ngang_5152294265.png",
    },
    {
      id: "brand-screen-id-5",
      name: "samsung",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_samsung_ngang_1624d75bd8.png",
    },
    {
      id: "brand-screen-id-6",
      name: "MSI",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_msi_ngang_fff5dcae79.png",
    },
    {
      id: "brand-screen-id-7",
      name: "apple",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_apple_ngang_1810642801.png",
    },
    {
      id: "brand-screen-id-8",
      name: "vsp",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_vsp_ngang_6c4014e7e7.png",
    },
    {
      id: "brand-screen-id-9",
      name: "LG",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_lg_ngang_bf97e628d1.png",
    },
  ],
  6: [
    {
      id: "brand-ipad-1",
      name: "lenovo",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_lenovo_ngang_9db13437a1.png",
    },
    {
      id: "brand-ipad-2",
      name: "samsung",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_samsung_ngang_1624d75bd8.png",
    },
    {
      id: "brand-ipad-3",
      name: "xiaomi",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_xiaomi_ngang_0faf267234.png",
    },

    {
      id: "brand-ipad-5",
      name: "masstel",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_masstel_ngang_2a96b9898c.png",
    },
  ],
  7: [
    {
      id: "brand-headphones-id-1",
      name: "havit",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_havit_ngang_93634c9e11.png",
    },
    {
      id: "brand-headphones-id-2",
      name: "bose",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_bose_ngang_b9288053ca.png",
    },
    {
      id: "brand-headphones-id-3",
      name: "hyper",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_hyperx_ngang_19dd1ca42a.png",
    },
    {
      id: "brand-headphones-id-4",
      name: "sony",
      img: "https://cdn2.fptshop.com.vn/unsafe/180x0/filters:format(webp):quality(75)/small/logo_sony_ngang_605fd1874e.png",
    },
    {
      id: "brand-headphones-id-5",
      name: "huawei",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_huawei_ngang_64107bb39f.png",
    },
    {
      id: "brand-headphones-id-6",
      name: "MSI",
      img: "https://cdn2.fptshop.com.vn/unsafe/256x0/filters:format(webp):quality(75)/small/logo_msi_ngang_fff5dcae79.png",
    },
  ],
};
